import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "../context/TranslationContext";
import AuthForms from "../components/auth/AuthForms";
import Badge from "../components/ds/Badge";
import { safeAuthRedirect } from "../utils/authRedirect";

/*
  Figma: "ეკრანები · A · შესვლამდე" → A2 · შესვლა და რეგისტრაცია (Join | Sign in).
  Desktop ≥ 1024: intro and card side by side. Below that they stack:
  tablet ≥ 600 pads 64, phone pads 16 / 24.
*/

const AuthPage = ({
  isDark,
  setToast
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const redirectTo = safeAuthRedirect(location.state?.from);
  const [activeForm, setActiveForm] = useState("signup");

  const signupTaglines = [
    t("auth.taglineEarnMoney"),
    t("auth.taglineGetPaid"),
    t("auth.taglineMonetizeAudience"),
    t("auth.taglineGrowCommunity"),
  ];

  return (
    <main
      data-theme={isDark ? "dark" : "light"}
      className="relative z-10 flex min-h-screen w-full flex-col gap-space-24 bg-bg-base px-space-16 py-space-24 font-ds text-label-primary min-[600px]:gap-space-40 min-[600px]:p-[64px] lg:flex-row lg:items-center lg:justify-center lg:gap-[64px] xl:gap-[96px] xl:px-[96px]"
    >
      <section className="flex w-full flex-col gap-space-12 min-[600px]:gap-space-20 lg:w-[520px] lg:min-w-0 lg:shrink">
        <div className="flex items-center gap-space-12">
          <span className="size-8 shrink-0 rounded-radius-sm bg-accent-default" aria-hidden="true" />
          <Badge>Mintly creators hub</Badge>
        </div>
        {activeForm === "signup" ? (
          <>
            <h1 className="text-title-1 min-[600px]:text-large-title">{t("auth.createBusinessInASecond")}</h1>
            <div className="flex flex-wrap gap-space-8">
              {signupTaglines.map((line) => (
                <Badge key={line}>{line}</Badge>
              ))}
            </div>
          </>
        ) : (
          <>
            <h1 className="text-title-1 min-[600px]:text-large-title">
              {t("authPage.headlineBuild")}{" "}
              <span className="text-accent-text">{t("authPage.headlineCollabs")}</span>
            </h1>
            <p className="text-body text-label-secondary">{t("authPage.accentSignin")}</p>
            <div className="flex flex-wrap gap-space-8">
              <Badge>{t("authPage.badgeInfluencers")}</Badge>
              <Badge>{t("authPage.badgeValidation")}</Badge>
            </div>
          </>
        )}
      </section>

      <section className="w-full rounded-radius-xl border border-separator-default bg-bg-raised p-space-20 min-[600px]:p-space-32 lg:w-[480px] lg:shrink-0">
        <AuthForms
          isDark={isDark}
          setToast={setToast}
          activeForm={activeForm}
          onFormChange={setActiveForm}
          redirectTo={redirectTo}
          onAuthenticated={() => navigate(redirectTo || "/")}
        />
      </section>
    </main>
  );
};

export default AuthPage;
